import { render, staticRenderFns } from "./appAssetHologram.vue?vue&type=template&id=31990a42&scoped=true"
import script from "./appAssetHologram.vue?vue&type=script&lang=js"
export * from "./appAssetHologram.vue?vue&type=script&lang=js"
import style0 from "./appAssetHologram.vue?vue&type=style&index=0&id=31990a42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31990a42",
  null
  
)

export default component.exports